<template>
  <div class="sticker-component"><slot /></div>
</template>

<style lang="postcss" scoped>
.sticker-component {
  @apply items-center text-white flex rounded-full font-bold px-[0.625rem] py-[0.375rem] gap-[0.625rem] bg-brand-primary;

  i {
    @apply text-lg;
  }
}

.alt {
  .sticker-component {
    @apply rounded-sm;
  }
}

.wl,
.tp {
  .sticker-component {
    @apply bg-green;
  }
}
</style>
